module.exports = __webpack_public_path__ + "media/guatemala/BAC_LOGO-e7feb0d8.png";